/**
 * LP（ヘッダー・フッター非表示ページ）から遷移する際に、
 * リンクに ?hide_layout=true パラメータを付与して、
 * 遷移先でもヘッダー・フッターを非表示にする
 */

(function() {
  'use strict';

  // ページが完全に読み込まれた後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinkModifier);
  } else {
    initLinkModifier();
  }

  function initLinkModifier() {
    // 内部リンク（商品、コレクション、ページなど）を取得
    const internalLinks = document.querySelectorAll('a[href^="/products/"], a[href^="/collections/"], a[href^="/pages/"], a[href*="' + window.location.hostname + '"]');
    
    internalLinks.forEach(function(link) {
      // すでにパラメータが付与されている場合はスキップ
      if (link.href.includes('hide_layout=true')) {
        return;
      }

      // data-属性で除外設定がある場合はスキップ
      if (link.dataset.keepLayout === 'true') {
        return;
      }

      // クリック時にパラメータを付与
      link.addEventListener('click', function(e) {
        const url = new URL(link.href);
        
        // アンカーリンク（#）やメールリンク（mailto:）は除外
        if (link.href.startsWith('#') || link.href.startsWith('mailto:') || link.href.startsWith('tel:')) {
          return;
        }

        // パラメータを追加
        url.searchParams.set('hide_layout', 'true');
        
        // target="_blank" の場合はそのまま
        if (link.target === '_blank') {
          link.href = url.toString();
          return;
        }

        // 通常のクリックの場合は遷移を上書き
        e.preventDefault();
        window.location.href = url.toString();
      }, { once: true }); // 1度だけ実行
    });

    // Ajaxで動的に追加されるリンクにも対応（MutationObserver）
    observeDynamicLinks();
  }

  function observeDynamicLinks() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // 要素ノードのみ
            if (node.tagName === 'A') {
              modifyLink(node);
            } else if (node.querySelectorAll) {
              const links = node.querySelectorAll('a[href^="/products/"], a[href^="/collections/"], a[href^="/pages/"]');
              links.forEach(modifyLink);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function modifyLink(link) {
    if (link.href.includes('hide_layout=true') || link.dataset.keepLayout === 'true') {
      return;
    }

    link.addEventListener('click', function(e) {
      const url = new URL(link.href);
      
      if (link.href.startsWith('#') || link.href.startsWith('mailto:') || link.href.startsWith('tel:')) {
        return;
      }

      url.searchParams.set('hide_layout', 'true');
      
      if (link.target === '_blank') {
        link.href = url.toString();
        return;
      }

      e.preventDefault();
      window.location.href = url.toString();
    }, { once: true });
  }
})();
